import { Component, inject, Injector, runInInjectionContext } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import {
  FileService,
  notify,
  retriveCurrentRouteData,
  SiaNewRouterService,
  SiaRouteData,
  SiaSessionService,
  SiaTranslatePipe,
} from '@sia/shared';
import { Subscription } from 'rxjs';
import { SiaPdfViewerComponent } from '../../components/sia-pdf-viewer/sia-pdf-viewer.component';
import { PortalDocumentService } from '../../services/portal-document.service';

@Component({
  selector: 'sia-pdf-session-viewer',
  templateUrl: './sia-pdf-session-viewer.component.html',
  styleUrls: ['./sia-pdf-session-viewer.component.css'],
  standalone: true,
  imports: [SiaPdfViewerComponent, MatIconButton, MatIcon, MatTooltip, SiaTranslatePipe],
})
export class SiaPdfSessionViewerComponent {
  private routerService = inject(SiaNewRouterService);
  private portalDocumentService = inject(PortalDocumentService);
  private sessionService = inject(SiaSessionService);
  private fileService = inject(FileService);
  private injector: Injector = inject(Injector);

  private _subs: Subscription[] = [];
  pageData: SiaRouteData = {};
  documentBase64: any;
  path: string | null | undefined;
  configurationName: string | null | undefined;

  loadFile() {
    if (!this.pageData.componentId || !this.path) {
      return;
    }
    this.fileService.getBlob(this.path).then((res: any) => {
      this.documentBase64 = res;
    });
  }

  /**
   * Download del file corrente gestito IN PAGINA (pulsante dedicato), non piu' tramite un'azione toolbar.
   * Questo evita la dipendenza di `@sia/pdf` da `@sia/actions`: quella dipendenza chiudeva l'anello di
   * build wireit `input -> file-preview -> pdf -> action -> input`. Il download effettivo era gia' fatto
   * da `FileService.downloadFile` (`@sia/shared`); l'azione era solo il trigger.
   */
  download() {
    if (!this.path) {
      return;
    }
    try {
      this.fileService.downloadFile(this.path, this.path.split(/[\/\\]+/).pop() || 'download', true, false);
    } catch (error) {
      console.error('Errore durante il download del file:', error);
      notify('Errore durante il download del file', 2000, 'error');
    }
  }

  ngOnDestroy() {
    this._subs.forEach((sub) => {
      sub.unsubscribe();
    });
  }
  ngAfterViewInit() {
    let s0 = this.routerService.routeChanged$.subscribe(() => {
      var pageData: any = null;
      runInInjectionContext(this.injector, () => {
        pageData = retriveCurrentRouteData() ?? {};
      });
      if (!pageData?.guid || pageData?.guid == this.pageData?.guid) {
        return;
      }
      this.pageData = pageData;
      this.path = this.sessionService.getSessionParamValue('path');
      this.configurationName = this.sessionService.getSessionParamValue('configurationType');
      this.loadFile();
    });
    this._subs.push(s0);
  }
}
